// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"bef0cb02","534":"6a1c9a4d","585":"6a1c9a4d","607":"6a1c9a4d","749":"bef0cb02"}[chunkId] + ".chunk.css";
};